module.exports = __webpack_public_path__ + "img/xm10-b6d3a5.png";